module.exports = __webpack_public_path__ + "static/media/actioncreation.e2d5fbc5.png";